import {
  FormRadio
} from "./chunk-DFHZIFWP.js";
import {
  FormSelectDropdown
} from "./chunk-2G2H5HCA.js";
import {
  A
} from "./chunk-IMO44CPR.js";
import {
  FormAgeField
} from "./chunk-P7K7UUGE.js";
import {
  FormDateRangePicker
} from "./chunk-WVY656PJ.js";
import {
  Label
} from "./chunk-NCTNDEQ3.js";
import {
  FormEditor
} from "./chunk-6FWH3O46.js";
import {
  UtilsStore
} from "./chunk-572FBZJF.js";
import {
  ThemesSwitcher
} from "./chunk-DXNAHFM5.js";
import {
  ErrorBoundary
} from "./chunk-GNASQP25.js";
import {
  NotFound
} from "./chunk-VN5TCXRT.js";
import {
  SVGComponent
} from "./chunk-C5UZGLWY.js";
import {
  Hambuger
} from "./chunk-FB6FH7DE.js";
import {
  LanguagesSwitcher
} from "./chunk-HMVSC6TJ.js";
import {
  AesirXSelectExtended
} from "./chunk-KWL576JA.js";
import {
  customStyles_default
} from "./chunk-5IAIJTV5.js";
import {
  Logo
} from "./chunk-6LYV7PFE.js";
import {
  Spinner
} from "./chunk-POLRV4GK.js";
import {
  CustomizedDatePicker
} from "./chunk-7SBVZY5O.js";
import {
  Toast,
  notify
} from "./chunk-DL5QNKBI.js";
import {
  history
} from "./chunk-MX4OMHUR.js";
import {
  ComponentSVG
} from "./chunk-APR4SZIP.js";
import {
  Image
} from "./chunk-2MXWHUGP.js";
import {
  AesirXI18nextProvider
} from "./chunk-DQPEKNUI.js";
import {
  ThemesContext,
  ThemesContextProvider
} from "./chunk-DB7NRMFG.js";
import {
  FORMAT_DATE,
  FORMAT_TIME,
  FORM_FIELD_TYPE
} from "./chunk-IIJXEE2D.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import {
  __publicField
} from "./chunk-JCO6WRHX.js";

// src/layouts/AuthLayout/index.tsx
import React14, { Suspense as Suspense3 } from "react";
import { Route as Route4, Redirect as Redirect3 } from "react-router-dom";

// src/providers/AppProvider.tsx
import React13, { createContext, useContext } from "react";
import { BrowserRouter, Route as Route3, Router, Switch } from "react-router-dom";

// src/layouts/MainLayout/index.tsx
import React11, { Suspense } from "react";
import { Redirect, Route } from "react-router-dom";

// src/components/Header/index.tsx
import React2, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";

// src/components/Header/index.scss
var css = `/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
.wr_input_search {
  width: 656px !important;
}

.top-30px {
  top: 30px;
}

.wrapper_dropdown .dropdown-menu.show {
  min-width: 400px;
}

.wrapper_avatar .dropdown-menu.show {
  min-width: 230px;
}

.item_collap {
  width: 24px;
  height: 24px;
  left: -12px;
}
.item_collap svg {
  transition: all 0.4s ease;
}

.mini_left .wrapper_header_logo {
  background-color: #0c1124;
}
.mini_left .w-260 {
  width: 110px !important;
}
.mini_left .header_logo {
  color: #fff;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: auto;
  margin-top: 5px;
}
.mini_left .menu_title {
  display: none;
}
.mini_left .item_collap svg {
  transform: rotateY(180deg);
}
.mini_left #wr_list_menu > .item_menu #wr_list_submenu {
  height: auto !important;
}
.mini_left #wr_list_menu > .item_menu #wr_list_submenu.show {
  display: none;
}
.mini_left #wr_list_menu > .item_menu #wr_list_submenu .mini-text-wrapper .text {
  display: none;
}
.mini_left #wr_list_menu > .item_menu #wr_list_submenu .mini-text-wrapper .mini-text {
  display: inline-block;
}
.mini_left #wr_list_menu > .item_menu:hover #wr_list_submenu {
  display: block;
}
.mini_left #wr_list_menu > .item_menu > .link_menu {
  text-align: center;
}
.mini_left #wr_list_menu > .item_menu > .link_menu .text {
  visibility: hidden;
  display: none !important;
}
.mini_left #wr_list_submenu {
  position: absolute;
  left: 100%;
  top: 0;
}
.mini_left .item_menu {
  position: relative;
}
.mini_left .item_menu .link_menu {
  position: relative;
}
.mini_left .item_menu .icon.arrow {
  display: none !important;
}
.mini_left .sidebar {
  padding-left: 0;
  padding-right: 0;
  overflow: unset;
}
.mini_left .item_upgrade {
  display: none;
}
.mini_left .link_upgrade span {
  display: none;
}
.mini_left .wr_list_menu_2 {
  padding: 0 !important;
}
.mini_left .section_menu_title {
  padding-left: 0 !important;
  padding-right: 0 !important;
  font-size: 11px;
  color: #fff;
}
.mini_left .version {
  display: none;
}

.all_project .dropdown {
  display: none;
}

.all_header .all_project .dropdown {
  display: block;
}

.show_menu_left {
  transition: 0.5s all ease-in-out;
}

@media (max-width: 1199.98px) {
  .sidebar {
    position: fixed !important;
    left: -260px;
    top: 0;
    bottom: 0;
  }
  .sdbar_right {
    right: -100% !important;
    z-index: 50;
  }
  .wrapper_header_logo {
    width: auto;
    background-color: #0c1124;
  }
  .content_header {
    border-left: 0 !important;
  }
  .content_header .item_collap {
    display: none !important;
  }
  .wr_input_search {
    width: 300px !important;
  }
  .show_menu_left {
    transform: translateX(260px);
  }
  .show_menu_left .wrapper_header .item_hambuger:first-child {
    transform: rotate(-45deg) translate(-5px, 5px);
  }
  .show_menu_left .wrapper_header .item_hambuger:nth-child(2) {
    opacity: 0;
  }
  .show_menu_left .wrapper_header .item_hambuger:last-child {
    transform: rotate(45deg) translate(-5px, -5px);
  }
}
@media (max-width: 991.98px) {
  .wrapper_avatar .text,
  .wrapper_avatar .icons {
    display: none;
  }
  .wr_help_center .text {
    display: none;
  }
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));

// src/components/Profile/index.tsx
import React from "react";
import { logout, Helper, Storage, AUTHORIZATION_KEY } from "aesirx-lib";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// src/assets/images/avatar.png
var avatar_default = "data:image/png;base64,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";

// src/assets/images/sign_out.svg
var sign_out_default = 'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M14.575 19.7521H17.275C17.5871 19.7654 17.8987 19.717 18.1921 19.6097C18.4855 19.5024 18.7548 19.3384 18.9847 19.1269C19.2145 18.9154 19.4005 18.6606 19.5318 18.3772C19.6631 18.0938 19.7373 17.7873 19.75 17.4751V6.27915C19.7373 5.96704 19.6631 5.6605 19.5318 5.37708C19.4005 5.09366 19.2145 4.83892 18.9847 4.62743C18.7548 4.41594 18.4855 4.25185 18.1921 4.14456C17.8987 4.03727 17.5871 3.98887 17.275 4.00215H14.575C14.396 4.00215 14.2243 4.07326 14.0977 4.19985C13.9711 4.32644 13.9 4.49813 13.9 4.67715C13.9 4.85617 13.9711 5.02786 14.0977 5.15444C14.2243 5.28103 14.396 5.35215 14.575 5.35215H17.275C17.5422 5.32891 17.8082 5.40943 18.0176 5.57699C18.2271 5.74456 18.364 5.98633 18.4 6.25215V17.4751C18.364 17.741 18.2271 17.9827 18.0176 18.1503C17.8082 18.3179 17.5422 18.3984 17.275 18.3751H14.575C14.396 18.3751 14.2243 18.4463 14.0977 18.5729C13.9711 18.6994 13.9 18.8711 13.9 19.0501C13.9 19.2292 13.9711 19.4009 14.0977 19.5274C14.2243 19.654 14.396 19.7251 14.575 19.7251V19.7521ZM8.275 16.1521C8.36369 16.1526 8.45156 16.1353 8.53347 16.1013C8.61538 16.0673 8.68968 16.0172 8.752 15.9541C8.8784 15.8276 8.94941 15.656 8.94941 15.4771C8.94941 15.2983 8.8784 15.1267 8.752 15.0001L5.629 11.8771L8.752 8.75415C8.81832 8.69235 8.87151 8.61783 8.9084 8.53503C8.9453 8.45223 8.96513 8.36285 8.96673 8.27222C8.96833 8.18158 8.95166 8.09156 8.91771 8.00751C8.88376 7.92346 8.83323 7.84711 8.76913 7.78301C8.70504 7.71892 8.62869 7.66839 8.54464 7.63444C8.46059 7.60049 8.37056 7.58382 8.27993 7.58541C8.1893 7.58701 8.09991 7.60685 8.01711 7.64374C7.93431 7.68064 7.85979 7.73383 7.798 7.80015L4.198 11.4001C4.07159 11.5267 4.00059 11.6983 4.00059 11.8771C4.00059 12.056 4.07159 12.2276 4.198 12.3541L7.798 15.9541C7.86032 16.0172 7.93461 16.0673 8.01653 16.1013C8.09844 16.1353 8.18631 16.1526 8.275 16.1521Z" fill="white"/>%0A<path d="M4.675 12.5531H14.575C14.754 12.5531 14.9257 12.482 15.0523 12.3554C15.1789 12.2288 15.25 12.0571 15.25 11.8781C15.25 11.6991 15.1789 11.5274 15.0523 11.4008C14.9257 11.2742 14.754 11.2031 14.575 11.2031H4.675C4.49598 11.2031 4.32429 11.2742 4.1977 11.4008C4.07112 11.5274 4 11.6991 4 11.8781C4 12.0571 4.07112 12.2288 4.1977 12.3554C4.32429 12.482 4.49598 12.5531 4.675 12.5531Z" fill="white"/>%0A</svg>%0A';

// src/components/Profile/index.tsx
import { Link } from "react-router-dom";
var Profile = () => {
  const { profileMenu } = useAppContext();
  const { t } = useTranslation();
  const preregistration = Storage.getItem("preregistration") ?? "";
  const CustomToggleAvatar = React.forwardRef(({ onClick }, ref) => /* @__PURE__ */ React.createElement(
    "div",
    {
      ref,
      onClick: (e) => {
        e.preventDefault();
        onClick(e);
      },
      className: "d-flex align-items-center text-decoration-none cursor-pointer"
    },
    /* @__PURE__ */ React.createElement(
      Image,
      {
        src: preregistration?.objForm?.avatar ? preregistration?.objForm?.avatar : Helper.isValidUrl(String(Storage.getItem(AUTHORIZATION_KEY.AVATAR))) ? Storage.getItem(AUTHORIZATION_KEY.AVATAR) : avatar_default,
        alt: "",
        className: "img-avatar rounded-circle object-fit-cover h-45"
      }
    )
  ));
  return /* @__PURE__ */ React.createElement("div", { className: "pe-4 me-2" }, /* @__PURE__ */ React.createElement("div", { className: "wrapper_avatar position-relative" }, /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      as: CustomToggleAvatar,
      id: "dropdown-custom-components position-relative"
    }
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, { className: "shadow border-0 px-16" }, /* @__PURE__ */ React.createElement("div", { className: "text px-16 pe-2" }, /* @__PURE__ */ React.createElement("p", { className: "mb-0 fs-14 px-3 pb-2 pt-3 fw-bold" }, /* @__PURE__ */ React.createElement(React.Fragment, null, preregistration?.objForm?.id ?? Storage.getItem(AUTHORIZATION_KEY.MEMBER_FULL_NAME)))), profileMenu && /* @__PURE__ */ React.createElement("div", { className: "" }, /* @__PURE__ */ React.createElement("ul", { className: "list-unstyled ps-0 mb-0 list_menu_avatar" }, profileMenu?.map((value, index) => {
    return /* @__PURE__ */ React.createElement("li", { key: index }, /* @__PURE__ */ React.createElement(Dropdown.Item, { className: "text-body d-block rounded-1 text-decoration-none p-0" }, /* @__PURE__ */ React.createElement(Link, { className: "d-block p-16 text-decoration-none", to: value.link }, t(value.text))));
  }))), /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: logout,
      className: "d-flex align-items-center border-gray cursor-pointer py-10px px-3 fw-medium cursor-pointer w-100 text-start d-flex align-items-center fs-7 btn btn-danger rounded-3"
    },
    /* @__PURE__ */ React.createElement(Image, { src: sign_out_default, alt: "", width: 24, height: 24 }),
    /* @__PURE__ */ React.createElement("span", { className: "ms-2" }, t("txt_sign_out"))
  )))));
};

// src/components/Header/index.tsx
var Header = ({ children, logo, isColorMode }) => {
  const { noavatar, integration, rootId } = useAppContext();
  const [isMini, setMini] = useState(integration);
  useEffect(() => {
    if (isMini) {
      document.querySelector(rootId).classList.add("mini_left");
    }
  }, []);
  const handleMenuLeft = () => {
    document.querySelector(rootId).classList.toggle("show_menu_left");
  };
  const handleCollap = () => {
    document.querySelector(rootId).classList.toggle("mini_left");
    setMini(!isMini);
  };
  return /* @__PURE__ */ React2.createElement(
    "div",
    {
      id: "all_header",
      className: `wrapper_header d-flex position-fixed w-100 left-0 right-0 pr-3 align-items-center shadow-sm z-index-100  ${integration ? "top-30px" : "top-0"}`
    },
    /* @__PURE__ */ React2.createElement(Hambuger, { handleAction: handleMenuLeft }),
    /* @__PURE__ */ React2.createElement(Logo, { isMini, logo }),
    /* @__PURE__ */ React2.createElement("div", { className: "content_header h-80 b flex-1 d-flex align-items-center ps-2 ps-lg-4 position-relative w-50 w-lg-100 bg-blue-5" }, /* @__PURE__ */ React2.createElement(
      "span",
      {
        className: "\n              item_collap\n              d-none\n              position-absolute\n              text-green\n              bg-blue-1\n              rounded-circle\n              align-items-center\n              justify-content-center\n              fs-12\n              cursor-pointer\n            ",
        onClick: handleCollap
      },
      /* @__PURE__ */ React2.createElement(FontAwesomeIcon, { icon: faChevronLeft })
    ), /* @__PURE__ */ React2.createElement("div", { className: "d-flex justify-content-end flex-1 align-items-center" }, children, /* @__PURE__ */ React2.createElement(LanguagesSwitcher, null), isColorMode && /* @__PURE__ */ React2.createElement(ThemesSwitcher, null), !noavatar && /* @__PURE__ */ React2.createElement(Profile, null)))
  );
};

// src/components/Form/Helper.tsx
import React5 from "react";
import { Form } from "react-bootstrap";

// src/components/Form/FormSelection/index.tsx
import React4, { Component } from "react";

// src/components/Select/Creatable.tsx
import React3 from "react";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { withTranslation } from "react-i18next";
var CreatableComponent = class extends React3.Component {
  constructor(props) {
    super(props);
    __publicField(this, "createOption", (label) => ({
      label,
      value: label
    }));
    __publicField(this, "handleKeyDown", async (event) => {
      if (!this.state.inputValue)
        return;
      switch (event.key) {
        case "Enter":
        case "Tab":
          await this.setState((prevState) => {
            return {
              ...prevState,
              inputValue: "",
              value: [...prevState.value, this.createOption(this.state.inputValue)]
            };
          });
          this.props.onChange(this.state.value);
          event.preventDefault();
      }
    });
    this.state = {
      value: props.defaultValue ?? [],
      inputValue: ""
    };
  }
  render() {
    const { t } = this.props;
    const { theme } = this.context;
    const { isBorder, placeholder, arrowColor, onChange, size, minWidth } = this.props;
    let { plColor } = this.props;
    const creatable = true;
    if (theme == "dark") {
      plColor = "#bfc9f7";
    }
    const styles = customStyles_default(isBorder, plColor, arrowColor, creatable, size, minWidth);
    const ClearIndicator = (props) => {
      const {
        children = /* @__PURE__ */ React3.createElement("div", { className: "text-danger" }, t("txt_remove_all")),
        getStyles,
        innerProps: { ref, ...restInnerProps }
      } = props;
      return /* @__PURE__ */ React3.createElement(
        "div",
        {
          ...restInnerProps,
          ref,
          style: {
            ...getStyles("clearIndicator", props),
            position: "absolute",
            top: "-38px",
            right: "0",
            paddingRight: 0
          }
        },
        /* @__PURE__ */ React3.createElement("div", { style: { padding: "0px 5px" } }, children)
      );
    };
    const MultiValueRemove = (props) => {
      return /* @__PURE__ */ React3.createElement(components.MultiValueRemove, { ...props }, /* @__PURE__ */ React3.createElement(SVGComponent, { url: "/assets/images/cancel.svg", color: "#C0C0C0" }));
    };
    return /* @__PURE__ */ React3.createElement(
      CreatableSelect,
      {
        ...this.props,
        components: {
          ClearIndicator,
          MultiValueRemove,
          DropdownIndicator: null
        },
        styles,
        inputValue: this.state.inputValue,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        placeholder: placeholder ?? t("txt_type_something_and_press_enter"),
        onChange: (newValue) => {
          onChange(newValue);
          return this.setState((prevState) => {
            return {
              ...prevState,
              value: newValue
            };
          });
        },
        onInputChange: (newValue) => this.setState((prevState) => {
          return {
            ...prevState,
            inputValue: newValue
          };
        }),
        onKeyDown: this.handleKeyDown,
        value: this.state.value
      }
    );
  }
};
CreatableComponent.contextType = ThemesContext;
var Creatable_default = withTranslation()(CreatableComponent);
var CreatableComponentExtended = withTranslation()(CreatableComponent);

// src/components/Form/FormSelection/index.tsx
var FormSelection = class extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleChange", (data) => {
      this.props.field.handleChange(data);
      this.setState({ field: data });
    });
    __publicField(this, "componentDidUpdate", (prevProps) => {
      if (prevProps.field.getValueSelected !== this.props.field.getValueSelected) {
        this.setState({ field: this.props.field.getValueSelected });
      }
    });
    this.state = { field: props.field.getValueSelected };
  }
  render() {
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, this.props.field.creatable ? /* @__PURE__ */ React4.createElement(
      CreatableComponentExtended,
      {
        defaultValue: this.props.field.getValueSelected,
        isBorder: true,
        arrowColor: this.props.field.arrowColor,
        placeholder: this.props.field.placeholder,
        className: "fs-14",
        onChange: this.props.field.handleChange,
        options: this.props.field.options
      }
    ) : /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(
      AesirXSelectExtended,
      {
        value: this.state.field ?? null,
        options: this.props.field?.getDataSelectOptions,
        className: "fs-14",
        isBorder: true,
        onBlur: this.props.field?.blurred,
        isMulti: this.props.field?.isMulti,
        onChange: this.handleChange,
        arrowColor: this.props.field?.arrowColor,
        placeholder: this.props.field?.placeholder,
        isDisabled: this.props.field?.isDisabled,
        size: "large",
        isClearable: this.props.field?.isClearable,
        async: this.props.field?.async,
        loadOptions: this.props.field?.loadOptions,
        defaultOptions: this.props.field?.defaultOptions
      }
    )));
  }
};

// src/components/Form/Helper.tsx
import { FontAwesomeIcon as FontAwesomeIcon2 } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
var renderingGroupFieldHandler = (group, validator) => Object.keys(group.fields).map(
  (fieldIndex) => [...Array(group.fields[fieldIndex])].map((field) => (() => renderField(field, validator))())
).reduce((arr, el) => arr.concat(el), []);
var renderField = (field, validator) => {
  const className = field.className ?? "";
  field.getValueSelected = field?.value ?? field?.getValueSelected;
  switch (field.type) {
    case FORM_FIELD_TYPE.INPUT:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: field.key, className: `mb-3 ${className}` }, /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(A, { field }), field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.TEXTAREA:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: field.key, className: `mb-3 ${className}` }, /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(
        Form.Control,
        {
          as: "textarea",
          defaultValue: field.getValueSelected,
          required: field.required ?? false,
          id: field.key,
          onChange: field.changed ?? void 0,
          onBlur: field.blurred ?? void 0
        }
      ));
    case FORM_FIELD_TYPE.DATERANGE:
      return /* @__PURE__ */ React5.createElement(FormDateRangePicker, { key: Math.random(), field, validator });
    case FORM_FIELD_TYPE.SELECTION:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: field.key, className: `mb-3 ${className}` }, field.label && /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(FormSelection, { key: Math.random(), field }), field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.DROPDOWN:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: Math.random(), className: `mb-3 ${className}` }, field.label && /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(FormSelectDropdown, { field }), field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.RADIO:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: Math.random(), className: `mb-3 ${className}` }, /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(FormRadio, { field }), field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.BIRTHDAY:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: Math.random(), className: `mb-3 ${className}` }, /* @__PURE__ */ React5.createElement(Label, { text: field.label }), /* @__PURE__ */ React5.createElement("div", { className: "form-control w-full" }, /* @__PURE__ */ React5.createElement(
        CustomizedDatePicker,
        {
          handleOnChange: (date) => field.changed(date),
          defaultDate: field.getValueSelected ? field.getValueSelected.split(" ")[0] : null
        }
      )));
    case FORM_FIELD_TYPE.AGE:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: Math.random(), className: `mb-3 ${className}` }, /* @__PURE__ */ React5.createElement(Label, { text: field.label, required: field.required ?? false }), /* @__PURE__ */ React5.createElement(FormAgeField, { field }), " ", field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.NUMBER:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: field.key, ref: field.ref, className: `mb-24 ${className}` }, field.label && /* @__PURE__ */ React5.createElement("div", { className: "d-flex align-item-center" }, /* @__PURE__ */ React5.createElement(
        Label,
        {
          text: field.label,
          isLabelHTML: field.isLabelHTML,
          required: field.required ?? false
        }
      )), /* @__PURE__ */ React5.createElement(A, { field }), field.validation && validator.message(field.label, field.getValueSelected, field.validation, {
        className: "text-danger"
      }));
    case FORM_FIELD_TYPE.EDITOR:
      return /* @__PURE__ */ React5.createElement(Form.Group, { key: field.key, className: `mb-24 ${className}` }, /* @__PURE__ */ React5.createElement("div", { className: "d-flex align-item-center" }, field.label && /* @__PURE__ */ React5.createElement(
        Label,
        {
          text: field.label,
          isLabelHTML: field.isLabelHTML,
          required: field.required ?? false
        }
      ), field.description && /* @__PURE__ */ React5.createElement(
        TooltipField,
        {
          keyTooltip: field?.key,
          description: field?.description,
          defaultValue: field?.default
        }
      )), field.isEditor === false ? /* @__PURE__ */ React5.createElement(
        Form.Control,
        {
          as: "textarea",
          defaultValue: field.getValueSelected,
          required: field.required ?? false,
          id: field.key,
          onChange: field.handleChange ?? void 0,
          onBlur: field.blurred ?? void 0,
          placeholder: field.placeholder,
          maxLength: field?.maxLength
        }
      ) : /* @__PURE__ */ React5.createElement(FormEditor, { field, key: field.key }), field.validation && validator.message(field.label, field.value, field.validation, {
        className: "text-danger"
      }));
    default:
      return /* @__PURE__ */ React5.createElement(React5.Fragment, null);
  }
};
var TooltipField = ({ keyTooltip, description, defaultValue }) => {
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
    FontAwesomeIcon2,
    {
      "data-tooltip-id": `tooltip-${keyTooltip}`,
      "data-tooltip-html": defaultValue ? description + `</br>Default: <strong>${defaultValue}</strong>` : description,
      className: "mx-sm fs-12 mb-1",
      icon: faCircleInfo
    }
  ), /* @__PURE__ */ React5.createElement(Tooltip, { id: `tooltip-${keyTooltip}` }));
};

// src/components/Menu/index.tsx
import React6, { useEffect as useEffect2, useState as useState2 } from "react";
import { useTranslation as useTranslation2 } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Collapse } from "react-bootstrap";

// src/components/Menu/index.scss
var css2 = `/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
.aesirxui .item_menu {
  margin-bottom: 8px;
}
.aesirxui .item_menu:last-child {
  margin-bottom: 0;
}
.aesirxui .item_menu .link_menu {
  transition: all 0.3s ease;
  white-space: nowrap;
  border-color: transparent;
}
.aesirxui .item_menu .link_menu:focus {
  outline: 0;
}
.aesirxui .item_menu .link_menu.active, .aesirxui .item_menu .link_menu:hover {
  background-color: #0a5aff;
  color: #fff;
}
.aesirxui .item_menu .link_menu.active i,
.aesirxui .item_menu .link_menu.active span, .aesirxui .item_menu .link_menu:hover i,
.aesirxui .item_menu .link_menu:hover span {
  color: #fff;
}
.aesirxui .item_menu .link_menu.active .icon:not(.arrow), .aesirxui .item_menu .link_menu:hover .icon:not(.arrow) {
  background-color: #fff !important;
}
.aesirxui .item_menu .link_menu.active .icon.arrow {
  transform: rotate(90deg);
}
.aesirxui .item_menu .link_menu i,
.aesirxui .item_menu .link_menu span {
  transition: all 0.3s ease;
}
.aesirxui .item_menu .link_menu .icon {
  width: 24px;
  height: 24px;
  background-color: var(--aesirxui-sidebar-menu-item-color);
}
.aesirxui .item_menu .link_menu .icon.arrow {
  width: 16px;
  height: 17px;
}
.aesirxui #wr_list_submenu {
  background-color: var(--aesirxui-sidebar-submenu-bg);
}
.aesirxui #wr_list_submenu .item_menu {
  margin-bottom: 8px;
}
.aesirxui #wr_list_submenu .item_menu:first-child {
  padding-top: 8px;
}
.aesirxui #wr_list_submenu .item_menu:last-child {
  padding-bottom: 8px;
  margin-bottom: 0;
}
.aesirxui #wr_list_submenu .item_menu .link_menu:hover, .aesirxui #wr_list_submenu .item_menu .link_menu.active {
  background-color: var(--aesirxui-sidebar-menu-item-hover-bg);
  color: var(--aesirxui-sidebar-menu-item-color);
}
.aesirxui #wr_list_submenu .item_menu .link_menu:hover i,
.aesirxui #wr_list_submenu .item_menu .link_menu:hover span, .aesirxui #wr_list_submenu .item_menu .link_menu.active i,
.aesirxui #wr_list_submenu .item_menu .link_menu.active span {
  color: var(--aesirxui-sidebar-menu-item-color);
}
.aesirxui #wr_list_submenu .mini-text-wrapper .mini-text {
  display: none;
}
.aesirxui .section_menu_title,
.aesirxui .header_logo {
  transition: all 0.3s ease;
}
.aesirxui .show .btn-success.dropdown-toggle:focus {
  box-shadow: none;
}
.aesirxui .sidebar {
  overflow-y: auto;
}
.aesirxui .sidebar .menu_title {
  padding: 0 24px;
}
.aesirxui .sidebar .data-stream-text {
  color: #3e545e;
}
.aesirxui .sidebar .data-stream .link_menu {
  padding: 0 24px;
}
.aesirxui .sidebar .data-stream .link_menu .data-stream-text {
  font-size: 0.875rem;
}
.aesirxui .sidebar .data-stream .link_menu .data-stream-value {
  font-size: 1.125rem;
}
.aesirxui .sidebar .data-stream .link_menu.show .data-stream-text, .aesirxui .sidebar .data-stream .link_menu:hover .data-stream-text {
  color: #fff;
}
.aesirxui .sidebar .button-language {
  padding-right: 24px;
}
.aesirxui .data-stream.item_menu .link_menu.dropdown-toggle {
  min-width: 200px;
}
@media (max-width: 991.98px) {
  .aesirxui .data-stream.item_menu .link_menu.dropdown-toggle {
    min-width: 100px;
  }
}
.aesirxui .data-stream.item_menu .link_menu:hover, .aesirxui .data-stream.item_menu .link_menu.show {
  color: #1ab394;
  background-color: transparent;
}
.aesirxui .data-stream.item_menu .link_menu:hover i,
.aesirxui .data-stream.item_menu .link_menu:hover span, .aesirxui .data-stream.item_menu .link_menu.show i,
.aesirxui .data-stream.item_menu .link_menu.show span {
  color: #1ab394 !important;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css2));

// src/assets/images/arrow-right.svg
var arrow_right_default = 'data:image/svg+xml,<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M6.02521 2.80938L10.3465 7.15605C10.8568 7.66938 10.8568 8.50938 10.3465 9.02272L6.02521 13.3694" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>%0A</svg>%0A';

// src/components/Menu/index.tsx
import { FontAwesomeIcon as FontAwesomeIcon3 } from "@fortawesome/react-fontawesome";
var Menu = ({ dataMenu, title = "" }) => {
  const { settingRoutes } = useAppContext();
  const match = useRouteMatch();
  const has = settingRoutes?.find((router) => router.path === match.path);
  const [isOpenCollapse, setIsOpenCollapse] = useState2("default");
  const { t } = useTranslation2();
  useEffect2(() => {
    checkActiveMenu();
  }, []);
  const handleOpen = (clickedIndex, parentIndex) => {
    if (isOpenCollapse === clickedIndex.toString()) {
      if (parentIndex) {
        setIsOpenCollapse(parentIndex.toString());
      } else {
        setIsOpenCollapse(null);
      }
    } else {
      if (isOpenCollapse?.includes(clickedIndex.toString())) {
        setIsOpenCollapse(null);
      } else {
        setIsOpenCollapse(clickedIndex.toString());
      }
    }
  };
  const checkActiveMenu = () => {
    if (window.location.pathname === "/") {
      document.getElementById("wr_list_menu")?.classList.remove("wr_list_menu");
    } else {
      document.getElementById("wr_list_menu")?.classList.add("wr_list_menu");
    }
  };
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, dataMenu && /* @__PURE__ */ React6.createElement("nav", { className: "main-menu py-24 mt-0" }, /* @__PURE__ */ React6.createElement("p", { className: "menu_title text-dark-blue fs-14 mb-0 text-uppercase pb-2" }, t(title ? title : has ? "txt_menu_setting" : "txt_main_menu")), /* @__PURE__ */ React6.createElement("ul", { id: "wr_list_menu", className: "list-unstyled mb-0 pt-md-1" }, dataMenu?.map((menuList, menuListkey) => {
    return /* @__PURE__ */ React6.createElement(
      "li",
      {
        key: menuListkey,
        className: `item_menu ${menuList.className ? menuList.className : ""}`
      },
      !menuList.submenu ? /* @__PURE__ */ React6.createElement(React6.Fragment, null, menuList.link && /* @__PURE__ */ React6.createElement(
        NavLink,
        {
          exact: true,
          to: menuList.link,
          className: `d-block px-24 py-16 mx-3 rounded link_menu text-gray-menu text-decoration-none fw-medium`,
          activeClassName: `active`,
          onClick: () => setIsOpenCollapse(null)
        },
        menuList.icons_color || menuList.icons_fa ? /* @__PURE__ */ React6.createElement("div", null, menuList.icons_fa ? /* @__PURE__ */ React6.createElement("i", null, /* @__PURE__ */ React6.createElement(FontAwesomeIcon3, { icon: menuList.icons_fa })) : /* @__PURE__ */ React6.createElement(
          "span",
          {
            className: "icon d-inline-block align-text-bottom",
            style: {
              WebkitMaskImage: `url(${menuList.icons_color})`,
              WebkitMaskRepeat: "no-repeat",
              backgroundColor: "#c8c8db"
            }
          }
        ), /* @__PURE__ */ React6.createElement("span", { className: "ms-16 text d-inline-block" }, t(menuList.text))) : /* @__PURE__ */ React6.createElement("span", { className: "text d-inline-block" }, t(menuList.text))
      )) : /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(
        NavLink,
        {
          to: menuList.link,
          onClick: () => handleOpen(menuListkey),
          className: `d-flex align-items-center justify-content-center rounded link_menu text-decoration-none text-break px-24 py-16 mx-3 shadow-none text-gray-menu fw-medium ${isOpenCollapse === menuListkey.toString() || isOpenCollapse?.includes(menuListkey + "-") || menuList?.submenu?.find(
            (item) => item?.link === history.location.pathname
          ) ? "active" : ""}`,
          "aria-controls": "wr_list_submenu",
          "aria-expanded": isOpenCollapse === menuListkey.toString() || isOpenCollapse?.includes(menuListkey + "-") || menuList?.submenu?.find(
            (item) => item?.link === history.location.pathname
          )
        },
        menuList.icons_color ? /* @__PURE__ */ React6.createElement(
          "span",
          {
            className: "icon d-inline-block align-text-bottom",
            style: {
              WebkitMaskImage: `url(${menuList.icons_color})`,
              WebkitMaskRepeat: "no-repeat",
              backgroundColor: "#c8c8db"
            }
          }
        ) : /* @__PURE__ */ React6.createElement(React6.Fragment, null),
        /* @__PURE__ */ React6.createElement(
          "span",
          {
            className: `${menuList.icons_color ? "ms-16" : ""} text d-inline-block`
          },
          t(menuList.text)
        ),
        /* @__PURE__ */ React6.createElement(
          "span",
          {
            className: "icon arrow d-inline-block align-text-bottom ms-auto",
            style: {
              WebkitMaskImage: `url('${arrow_right_default}')`,
              WebkitMaskRepeat: "no-repeat",
              backgroundColor: "#1AB394"
            }
          }
        )
      ), /* @__PURE__ */ React6.createElement(
        Collapse,
        {
          in: isOpenCollapse === menuListkey.toString() || isOpenCollapse?.includes(menuListkey + "-") || menuList?.submenu?.find(
            (item) => item?.link === history.location.pathname
          )
        },
        /* @__PURE__ */ React6.createElement("ul", { id: "wr_list_submenu", className: "list-unstyled" }, menuList.submenu.map((value, menuListSubkey) => {
          return /* @__PURE__ */ React6.createElement(
            "li",
            {
              key: menuListSubkey,
              className: `item_menu`,
              onClick: checkActiveMenu
            },
            value.link && /* @__PURE__ */ React6.createElement(
              NavLink,
              {
                exact: true,
                to: value.link,
                className: `d-block px-24 py-16 mx-3 rounded link_menu text-gray-menu text-decoration-none fw-medium`,
                activeClassName: `active`
              },
              value?.mini_text ? /* @__PURE__ */ React6.createElement("span", { className: "mini-text-wrapper" }, /* @__PURE__ */ React6.createElement("span", { className: "mini-text" }, t(value?.mini_text)), /* @__PURE__ */ React6.createElement("span", { className: "text" }, t(value.text))) : /* @__PURE__ */ React6.createElement("span", { className: "text ms-16 d-inline-block" }, t(value.text))
            )
          );
        }))
      ))
    );
  }))));
};

// src/components/SbarLeft/index.tsx
import React7 from "react";
import { Link as Link2, useRouteMatch as useRouteMatch2 } from "react-router-dom";
import { FontAwesomeIcon as FontAwesomeIcon4 } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { useTranslation as useTranslation3 } from "react-i18next";
var SbarLeft = () => {
  const { componentBottomMenu, leftMenu, settingMenu, settingRoutes } = useAppContext();
  const match = useRouteMatch2();
  const has = settingRoutes?.find((router) => router.path === match.path);
  const { t } = useTranslation3();
  let version = "";
  try {
    version = VERSION;
  } catch (error) {
  }
  return /* @__PURE__ */ React7.createElement(
    "aside",
    {
      className: `sidebar w-260 mt-0 mh-100 h-100 d-flex flex-column z-index-100 justify-content-between bg-menu overflow-y-auto`
    },
    has ? /* @__PURE__ */ React7.createElement("nav", null, /* @__PURE__ */ React7.createElement("div", { className: "py-1 px-3 item_menu item_menu_home" }, /* @__PURE__ */ React7.createElement(
      Link2,
      {
        to: "/",
        className: "d-block text-white p-3 link_menu rounded-2 text-decoration-none  "
      },
      /* @__PURE__ */ React7.createElement("i", null, /* @__PURE__ */ React7.createElement(FontAwesomeIcon4, { icon: faArrowLeft })),
      /* @__PURE__ */ React7.createElement("span", { className: "ms-3 text text-white" }, t("txt_back_to_dashboard"))
    )), settingMenu) : leftMenu,
    /* @__PURE__ */ React7.createElement("div", { className: "mx-3" }, componentBottomMenu, version && /* @__PURE__ */ React7.createElement("span", { className: "version ms-3 mb-3 text text-white fs-14" }, t("txt_version"), " ", version))
  );
};

// src/components/PublishOptions/index.tsx
import React10, { Component as Component3 } from "react";
import { withTranslation as withTranslation3 } from "react-i18next";
import { observer as observer2 } from "mobx-react";

// src/store/UtilsStore/UtilsViewModelContextProvider.tsx
import React8 from "react";

// src/store/UtilsStore/UtilsListViewModel.ts
import { makeAutoObservable, runInAction } from "mobx";
var UtilsListViewModel = class {
  constructor(utilsStore2) {
    __publicField(this, "utilsStore");
    __publicField(this, "formStatus", PAGE_STATUS.READY);
    __publicField(this, "utilsListViewModel", null);
    __publicField(this, "listPublishStatus", []);
    __publicField(this, "listPublishStatusSimple", []);
    __publicField(this, "listContentType", []);
    __publicField(this, "listFieldType", []);
    __publicField(this, "successResponse", {
      state: true,
      content_id: ""
    });
    __publicField(this, "setForm", (utilsListViewModel) => {
      this.utilsListViewModel = utilsListViewModel;
    });
    __publicField(this, "getListPublishStatus", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.utilsStore.getListPublishStatus();
      runInAction(() => {
        if (!data?.error) {
          this.callbackOnSuccessHandler(data?.response);
        } else {
          this.callbackOnErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "getListContentType", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.utilsStore.getListContentType();
      runInAction(() => {
        if (!data?.error) {
          this.callbackOnSuccessHandler(data?.response);
        } else {
          this.callbackOnErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "getListFieldType", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.utilsStore.getListFieldType();
      runInAction(() => {
        if (!data?.error) {
          this.callbackOnSuccessHandler(data?.response);
        } else {
          this.callbackOnErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "callbackOnErrorHandler", (error) => {
      notify("Something went wrong from Server response", "error");
      this.successResponse.state = false;
      this.successResponse.content_id = error.result;
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "callbackOnSuccessHandler", (result) => {
      if (result?.listPublishStatus) {
        this.listPublishStatus = result.listPublishStatus;
        this.listPublishStatusSimple = result.listPublishStatus.filter((obj) => {
          return obj.value === 0 || obj.value === 1;
        });
      }
      if (result?.listContentType) {
        this.listContentType = result.listContentType;
      }
      if (result?.listFieldType) {
        const usableFields = [
          "aesir_dam_asset",
          "checkbox",
          "editor",
          "radio",
          "number",
          "select",
          "text"
        ];
        this.listFieldType = result.listFieldType?.filter((item) => {
          return usableFields?.includes(item?.value);
        });
      }
      this.formStatus = PAGE_STATUS.READY;
    });
    makeAutoObservable(this);
    this.utilsStore = utilsStore2;
  }
};
var UtilsListViewModel_default = UtilsListViewModel;

// src/store/UtilsStore/UtilsViewModel.ts
var UtilsViewModel = class {
  constructor(utilsStore2) {
    __publicField(this, "utilsDetailViewModel", {});
    __publicField(this, "utilsListViewModel", {});
    __publicField(this, "getUtilsListViewModel", () => this.utilsListViewModel);
    if (utilsStore2) {
      this.utilsListViewModel = new UtilsListViewModel_default(utilsStore2);
    }
  }
};
var UtilsViewModel_default = UtilsViewModel;

// src/store/UtilsStore/UtilsViewModelContextProvider.tsx
var utilsStore = new UtilsStore();
var utilsViewModel = new UtilsViewModel_default(utilsStore);
var UtilsViewModelContext = React8.createContext({ model: utilsViewModel });
var UtilsViewModelContextProvider = ({ children }) => {
  return /* @__PURE__ */ React8.createElement(UtilsViewModelContext.Provider, { value: { model: utilsViewModel } }, children);
};
var useUtilsViewModel = () => React8.useContext(UtilsViewModelContext);
var withUtilsViewModel = (Component4) => (props) => {
  return /* @__PURE__ */ React8.createElement(Component4, { ...props, parentViewModel: props?.viewModel, ...useUtilsViewModel() });
};

// src/components/PublishOptions/PublishOptions.tsx
import React9, { Component as Component2 } from "react";
import { withTranslation as withTranslation2 } from "react-i18next";
import { Form as Form2 } from "react-bootstrap";
import { PIM_PRODUCT_DETAIL_FIELD_KEY, AUTHORIZATION_KEY as AUTHORIZATION_KEY2, Storage as Storage2 } from "aesirx-lib";
import { observer } from "mobx-react";
import { FontAwesomeIcon as FontAwesomeIcon5 } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
var PublishOptionsDetail = observer(
  class PublishOptionsDetail2 extends Component2 {
    constructor(props) {
      super(props);
      __publicField(this, "utilsListViewModel", null);
      this.utilsListViewModel = props.model.utilsListViewModel;
    }
    async componentDidMount() {
      if (!this.utilsListViewModel?.listPublishStatus.length) {
        await this.utilsListViewModel.getListPublishStatus();
      }
    }
    render() {
      const {
        t,
        detailViewModal,
        formPropsData,
        isEdit,
        isPublished = true,
        isPublishedSimple = false,
        isFeatured = true,
        isLastModified = true,
        isCreateBy = true
      } = this.props;
      const createBy = isEdit ? formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.CREATED_USER_NAME] : Storage2.getItem(AUTHORIZATION_KEY2.MEMBER_FULL_NAME);
      const modifiedBy = isEdit ? formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.MODIFIED_USER_NAME] : Storage2.getItem(AUTHORIZATION_KEY2.MEMBER_FULL_NAME);
      const listPublishStatus = isPublishedSimple ? this.utilsListViewModel?.listPublishStatusSimple : this.utilsListViewModel?.listPublishStatus;
      return /* @__PURE__ */ React9.createElement("div", { className: "p-24 bg-white rounded-1 shadow-sm" }, /* @__PURE__ */ React9.createElement("h5", { className: "fw-bold text-body text-uppercase fs-6 border-bottom pb-24 mb-24" }, t("txt_publish_options")), isPublished && /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center justify-content-between w-100 mb-24" }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement("div", { style: { marginLeft: "-5px" } }, /* @__PURE__ */ React9.createElement(ComponentSVG, { url: "/assets/images/post-status.svg", className: "bg-dark" }), "\xA0", t("txt_status"), ":")), /* @__PURE__ */ React9.createElement(Form2.Group, { style: { maxWidth: "200px", width: "65%" } }, /* @__PURE__ */ React9.createElement(
        FormSelection,
        {
          field: {
            getValueSelected: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.PUBLISHED] !== void 0 ? {
              label: t(
                `txt_${listPublishStatus?.find(
                  (x) => x.value.toString() === formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.PUBLISHED].toString()
                )?.label?.toString().toLowerCase()}`
              ),
              value: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.PUBLISHED].toString()
            } : null,
            getDataSelectOptions: listPublishStatus?.map((status) => ({
              label: t(`txt_${status?.label && status.label?.toString().toLowerCase()}`),
              value: status.value.toString()
            })),
            arrowColor: "var(--dropdown-indicator-color)",
            handleChange: (data) => {
              detailViewModal.handleFormPropsData(
                PIM_PRODUCT_DETAIL_FIELD_KEY.PUBLISHED,
                data.value
              );
            }
          }
        }
      ))), isLastModified && /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center justify-content-between w-100 mb-24 border-bottom pb-24" }, /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React9.createElement("i", { className: "me-2 mb-1" }, /* @__PURE__ */ React9.createElement(FontAwesomeIcon5, { icon: faUser })), t("txt_last_modified"), ":"), /* @__PURE__ */ React9.createElement("div", { className: "text-gray" }, modifiedBy)), isFeatured && /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center justify-content-between w-100 mb-24" }, /* @__PURE__ */ React9.createElement("div", null, t("txt_feature")), /* @__PURE__ */ React9.createElement(Form2.Group, null, /* @__PURE__ */ React9.createElement(
        FormRadio,
        {
          field: {
            key: PIM_PRODUCT_DETAIL_FIELD_KEY.FEATURED,
            getValueSelected: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.FEATURED] ? {
              label: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.FEATURED] === "1" ? t("txt_yes") : "No",
              value: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.FEATURED].toString()
            } : {
              label: "No",
              value: "0"
            },
            getDataSelectOptions: [
              {
                label: t("txt_yes"),
                value: "1"
              },
              {
                label: t("txt_no"),
                value: "0",
                className: "me-0"
              }
            ],
            handleChange: (data) => {
              detailViewModal.handleFormPropsData(
                PIM_PRODUCT_DETAIL_FIELD_KEY.FEATURED,
                data.target.value
              );
            }
          }
        }
      ))), /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center justify-content-between w-100 mb-24" }, /* @__PURE__ */ React9.createElement("div", null, t("txt_create_date"), ":"), /* @__PURE__ */ React9.createElement(Form2.Group, { style: { maxWidth: "200px", width: "65%" } }, /* @__PURE__ */ React9.createElement("div", { className: "fs-14" }, /* @__PURE__ */ React9.createElement(
        CustomizedDatePicker,
        {
          dateFormat: FORMAT_DATE + " " + FORMAT_TIME,
          defaultDate: formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.CREATED_TIME] ? formPropsData[PIM_PRODUCT_DETAIL_FIELD_KEY.CREATED_TIME] : /* @__PURE__ */ new Date(),
          isDisabled: true,
          showTimeSelect: true,
          isUTC: true
        }
      )))), isCreateBy && /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center justify-content-between w-100" }, /* @__PURE__ */ React9.createElement("div", null, t("txt_create_by"), ":"), /* @__PURE__ */ React9.createElement("div", { className: "text-gray" }, createBy)));
    }
  }
);
var PublishOptions_default = withTranslation2()(withUtilsViewModel(PublishOptionsDetail));

// src/components/PublishOptions/index.tsx
var PublishOptions = observer2(
  class PublishOptions2 extends Component3 {
    constructor(props) {
      super(props);
    }
    render() {
      return /* @__PURE__ */ React10.createElement(UtilsViewModelContextProvider, null, /* @__PURE__ */ React10.createElement(PublishOptions_default, { ...this.props }));
    }
  }
);
var A2 = withTranslation3()(PublishOptions);

// src/layouts/MainLayout/index.tsx
var MainLayout = ({ children, logo, isColorMode }) => {
  const { mainRoutes, isLogin, componentHeader, integration, noHeader } = useAppContext();
  return isLogin() ? /* @__PURE__ */ React11.createElement("div", { className: "container-fluid" }, /* @__PURE__ */ React11.createElement("div", { className: "row" }, /* @__PURE__ */ React11.createElement("main", { className: "p-0" }, !noHeader && /* @__PURE__ */ React11.createElement(Header, { logo, isColorMode }, componentHeader && componentHeader), /* @__PURE__ */ React11.createElement(
    "div",
    {
      className: `main_content vh-100 main_content_dashboard d-flex ${!noHeader && "pd-t-80"}`
    },
    /* @__PURE__ */ React11.createElement(SbarLeft, null),
    /* @__PURE__ */ React11.createElement("div", { className: "flex-1 mh-100 overflow-hidden overflow-y-auto position-relative main-content" }, /* @__PURE__ */ React11.createElement(Suspense, { fallback: /* @__PURE__ */ React11.createElement(Spinner, null) }, integration ? children : mainRoutes.map(({ path, exact, main }, i) => /* @__PURE__ */ React11.createElement(Route, { key: i, exact, path, component: main }))))
  )))) : /* @__PURE__ */ React11.createElement(Redirect, { to: "/login" });
};

// src/layouts/SettingLayout/index.tsx
import React12, { Suspense as Suspense2 } from "react";
import { Route as Route2, Redirect as Redirect2 } from "react-router-dom";
var SettingLayout = ({ logo, isColorMode }) => {
  const { isLogin, settingRoutes } = useAppContext();
  return isLogin() ? /* @__PURE__ */ React12.createElement("div", { className: "container-fluid" }, /* @__PURE__ */ React12.createElement("div", { className: "row" }, /* @__PURE__ */ React12.createElement("main", { className: "p-0" }, /* @__PURE__ */ React12.createElement(Header, { logo, isColorMode }), /* @__PURE__ */ React12.createElement("div", { className: "main_content vh-100 main_content_dashboard pd-t-80 d-flex" }, /* @__PURE__ */ React12.createElement(SbarLeft, null), /* @__PURE__ */ React12.createElement("div", { className: "flex-1 bg-body mh-100 overflow-hidden overflow-y-auto position-relative" }, /* @__PURE__ */ React12.createElement(Suspense2, { fallback: /* @__PURE__ */ React12.createElement(Spinner, null) }, settingRoutes.map(({ path, exact, main }, i) => /* @__PURE__ */ React12.createElement(Route2, { key: i, exact, path, component: main })))))))) : /* @__PURE__ */ React12.createElement(Redirect2, { to: "/login" });
};

// src/providers/AppProvider.tsx
var AppContext = createContext({
  authRoutes: [],
  mainRoutes: [],
  settingRoutes: [],
  isLogin: null,
  rootId: "#root",
  noavatar: false,
  integration: false,
  profileMenu: [],
  noHeader: false
});
var AppProvider = ({
  authRoutes,
  mainRoutes,
  appLanguages,
  isLogin,
  componentHeader,
  componentBottomMenu,
  rootId = "#root",
  noavatar = false,
  integration,
  children,
  leftMenu,
  profileMenu,
  settingRoutes,
  settingMenu,
  noHeader,
  logo,
  isColorMode = true
}) => {
  const authPath = authRoutes?.map((item) => {
    return item.path;
  }).reduce((arr, el) => {
    return arr.concat(el);
  }, []);
  const mainPath = mainRoutes?.map((item) => {
    return item.path;
  }).reduce((arr, el) => {
    return arr.concat(el);
  }, []);
  const settingPath = settingRoutes?.map((item) => {
    return item.path;
  }).reduce((arr, el) => {
    return arr.concat(el);
  }, []);
  return /* @__PURE__ */ React13.createElement(ErrorBoundary, null, /* @__PURE__ */ React13.createElement(
    AppContext.Provider,
    {
      value: {
        authRoutes,
        mainRoutes,
        settingRoutes,
        isLogin,
        componentHeader,
        componentBottomMenu,
        rootId,
        noavatar,
        integration,
        leftMenu,
        profileMenu,
        settingMenu,
        noHeader,
        logo
      }
    },
    /* @__PURE__ */ React13.createElement(ThemesContextProvider, null, /* @__PURE__ */ React13.createElement(AesirXI18nextProvider, { appLanguages }, /* @__PURE__ */ React13.createElement(Toast, null), /* @__PURE__ */ React13.createElement(BrowserRouter, null, integration ? /* @__PURE__ */ React13.createElement(MainLayout, { logo, isColorMode }, children) : /* @__PURE__ */ React13.createElement(Router, { history }, /* @__PURE__ */ React13.createElement(Switch, null, authPath && /* @__PURE__ */ React13.createElement(Route3, { exact: true, path: authPath }, /* @__PURE__ */ React13.createElement(AuthLayout, null)), settingPath && /* @__PURE__ */ React13.createElement(Route3, { exact: true, path: settingPath }, /* @__PURE__ */ React13.createElement(SettingLayout, { logo, isColorMode })), mainPath && /* @__PURE__ */ React13.createElement(Route3, { path: mainPath }, /* @__PURE__ */ React13.createElement(MainLayout, { logo, isColorMode })), /* @__PURE__ */ React13.createElement(Route3, { path: "*" }, /* @__PURE__ */ React13.createElement(NotFound, null)))))))
  ));
};
var useAppContext = () => useContext(AppContext);

// src/layouts/AuthLayout/index.tsx
var AuthLayout = () => {
  const { authRoutes, isLogin } = useAppContext();
  return isLogin() ? /* @__PURE__ */ React14.createElement(Redirect3, { to: "/" }) : /* @__PURE__ */ React14.createElement("div", { className: "container-fluid" }, /* @__PURE__ */ React14.createElement("div", { className: "row" }, /* @__PURE__ */ React14.createElement("main", null, /* @__PURE__ */ React14.createElement(Suspense3, { fallback: /* @__PURE__ */ React14.createElement(Spinner, null) }, authRoutes.map(({ path, exact, main }, i) => /* @__PURE__ */ React14.createElement(Route4, { key: i, exact, path, component: main }))))));
};

export {
  AuthLayout,
  Creatable_default,
  CreatableComponentExtended,
  FormSelection,
  renderingGroupFieldHandler,
  renderField,
  Menu,
  SbarLeft,
  UtilsListViewModel_default,
  UtilsViewModel_default,
  UtilsViewModelContext,
  UtilsViewModelContextProvider,
  useUtilsViewModel,
  withUtilsViewModel,
  PublishOptions_default,
  A2 as A,
  SettingLayout,
  AppProvider,
  useAppContext,
  Profile,
  Header,
  MainLayout
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
